<script setup lang="ts">
import type { BookAndArticle } from '~/utils/solr/literature'
import { faPenNib } from '@fortawesome/pro-light-svg-icons'

const { type } = defineProps<{
  book: BookAndArticle
  type: 'law-commentary' | 'book'
}>()

const hasLicense = useHasContentLicense()

const buttonText = computed(() => type === 'law-commentary'
  ? 'Les lovkommentaren'
  : 'Les boken',
)
</script>

<template>
  <div class="flex flex-col gap-m items-center min-[790px]:items-start">
    <hgroup class="flex flex-col gap-3xs text-center min-[790px]:text-left">
      <h1 class="title-l" v-text="book.title" />
      <p class="title-l !font-light" v-text="book.subtitle" />
    </hgroup>

    <div class="flex flex-col xl:flex-row gap-2xs md:gap-xs">
      <Chip v-if="!!book.authorName?.length" variant="outlined" color="carbon" :icon-left="faPenNib" size="small" class="text-primary flex-wrap !justify-start gap-x-3xs flex-auto">
        <template v-for="author in book.authorName" :key="author">
          <NuxtLink :to="{ name: 'author', params: { slug: author } }" class="text-caption underline text-secondary after:content-[','] last:after:content-['']">
            {{ author }}
          </NuxtLink>
        </template>
      </Chip>
      <ReadingMetadata :node="book" orientation="horizontal" />
    </div>

    <div class="flex items-center gap-s">
      <Button variant="primary" size="medium" :to="type === 'book' ? { name: 'book-by-id', params: { bokId: [book.id] } } : { path: $route.path, query: $route.query }">
        {{ buttonText }}
      </Button>
      <Button v-if="!hasLicense" variant="secondary" size="small" :to="{ name: 'product-catalogue' }">
        Kjøp&nbsp;abonnement
      </Button>
    </div>
  </div>
</template>
